import { ast, compiler } from 'peggy';

function consumesTrue() {
  return true;
}
function consumesFalse() {
  return false;
}

const DEFAULT_VISITOR_NONE = {
  simple_and: consumesFalse,
  simple_not: consumesFalse,
  optional: consumesFalse,
  zero_or_more: consumesFalse,
  semantic_and: consumesFalse,
  semantic_not: consumesFalse,
  library_ref() {
    return false;
  },
  literal(node) {
    return node.value !== '';
  },

  class: consumesTrue,
  any: consumesTrue
};

function createVisitor(
  grammer: ast.Grammar,
  options: Record<string, Function> = DEFAULT_VISITOR_NONE,
  args: Record<string, any> = {}
) {
  const consumes = compiler.visitor.build(options);
  return consumes(grammer, { ...args, visitor: consumes });
}
export { createVisitor };
